import striptags from 'striptags';

const allowedTags = ['br', 'strong', 'b', 'em', 'i', 'p', 'h1', 'h2', 'h3'];

export function htmlSubstring(html: string, count: number, allowed?: string[]) {
  const _html = striptags(html, allowed || allowedTags);

  if (!document) {
    return _html;
  }

  // https://stackoverflow.com/a/6003713
  const div = document.createElement('div');
  div.innerHTML = _html;

  walk(div, track);

  function track(el) {
    if (count > 0) {
      const len = el.data.length;
      count -= len;
      if (count <= 0) {
        el.data = el.substringData(0, el.data.length + count);
      }
    } else {
      el.data = '';
    }
  }

  function walk(el, fn) {
    let node = el.firstChild;
    do {
      if (node.nodeType === 3) {
        fn(node);
        // Added this >>------------------------------------<<
      } else if (node.nodeType === 1 && node.childNodes && node.childNodes[0]) {
        walk(node, fn);
      }
    } while ((node = node.nextSibling));
  }

  return div.innerHTML;
}
